import Menu from "bars/Menu";
import Page404 from "shared/pages/Page404";
import PageHome from "pages/PageHome";
import PageTacticAnalysis from "pages/PageTacticAnalysis.js";
import PageSquadBuilder from "pages/PageSquadBuilder.js";
import PageFormationMeta from "pages/PageFormationMeta.js";
import PageOpponentFinder from "pages/PageOpponentFinder.js";
import PageMatchPlanner from "pages/PageMatchPlanner.js";
import PageDivisionStrength from "pages/PageDivisionStrength.js";
import PageSearch from "shared/pages/PageSearch.js";
import PageUser from "shared/pages/PageUser.js";
import PageUserClubs from "shared/pages/pageuser/PageUserClubs.js";
import PageUserPlayers from "shared/pages/pageuser/PageUserPlayers.js";
import PageUserOverview from "shared/pages/pageuser/PageUserOverview.js";
import PageUserPerformance from "shared/pages/pageuser/PageUserPerformance.js";
import PageUserMap from "shared/pages/pageuser/PageUserMap.js";
import PagePlayer from "shared/pages/PagePlayer.js";
import PageClub from "shared/pages/PageClub.js";
import React, { useState } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";

const Router: React.FC = (props) => {
  const location = useLocation();
  const [yScrollPosition, setYScrollPosition] = useState(0);

  const handleScroll = (event) => {
    const { scrollTop } = event.target;
    const scroll = scrollTop;
    setYScrollPosition(scroll);
  };

  React.useEffect(() => {
    document.getElementById("AppContent-content").scroll({
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);

  return (
    <div id="Router" className="d-flex flex-column flex-lg-row h-100">
      <div id="AppMenu" className="order-2 order-lg-1">
        <Menu {...props} />
      </div>

      <div id="AppContent" className="order-1 order-lg-2 flex-fill">
        <div id="AppContent-content" className="position-relative h-100 w-100" onScroll={handleScroll}>
          <Routes>
            <Route
              path="/"
              element={
                <PageHome
                  flowUser={props.flowUser}
                  assistantUser={props.assistantUser}
                  updateAssistantUser={props.updateAssistantUser}
                  logout={props.logout}
                  yScrollPosition={yScrollPosition}
                  {...props}
                />
              }
            />
            <Route path="/tactic-analysis" element={<PageTacticAnalysis {...props} />} />
            <Route path="/squad-builder" element={<PageSquadBuilder {...props} />} />
            <Route path="user/:address" element={<PageUser {...props} yScrollPosition={yScrollPosition} />}>
              <Route index element={<Navigate to="overview" replace />} />
              <Route path="overview" element={<PageUserOverview {...props} />} />
              <Route path="players" element={<PageUserPlayers />} />
              <Route path="clubs" element={<PageUserClubs />} />
              <Route path="performance" element={<PageUserPerformance />} />
              <Route path="map" element={<PageUserMap />} />
            </Route>
            <Route path="/formation-meta" element={<PageFormationMeta {...props} />} />
            <Route path="/divisions" element={<PageDivisionStrength {...props} />} />
            <Route path="/match-planner" element={<PageMatchPlanner {...props} />} />
            <Route path="/opponent-finder" element={<PageOpponentFinder />} />
            <Route path="/search" element={<PageSearch />} />
            <Route path="/player/:id" element={<PagePlayer {...props} />} />
            <Route path="/club/:id" element={<PageClub {...props} />} />

            {/* 404 */}
            <Route element={<Page404 />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Router;
